import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Page, Spinner, Text } from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import React, { useState, useCallback, useEffect } from "react";
import moment from "moment";

const DealsBoard = () => {
  const [columns, setColumns] = useState(null);
  var randomColor = require("randomcolor");
  const [stages, setStages] = useState(null);
  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    let responseDeals = "";
    let responseStages = "";

    try {
      responseDeals = await axios.get(`/crm/deals?sort=order`);
      console.log(responseDeals.data.data.data);
    } catch (error) {
      console.log(error);
    }

    try {
      responseStages = await axios.get(`/crm/deal-stages`);
      setStages(
        responseStages?.data?.data?.data.map((item, index) => {
          return {
            id: index,
            value: item.id,
          };
        })
      );
      let array = [];
      for (var i = 0; i < responseDeals.data.data.data.length; i++) {
        let colorObjBgd = randomColor({
          format: "rgba",
          alpha: 0.4,
        });

        let colorObjTxt = `rgba(
            ${rgbToObj(colorObjBgd).red},
            ${rgbToObj(colorObjBgd).green},
            ${rgbToObj(colorObjBgd).blue},
            1
            
          )`;

        array.push({
          id: responseDeals.data.data.data[i].id,
          bgdColor: colorObjBgd,
          textColor: colorObjTxt,
        });
      }
      setColumns(
        responseStages?.data?.data?.data.map((item, index) => {
          return {
            id: index,
            name: capitalizeFirstLowercaseRest(item.name),
            items: responseDeals.data.data.data
              .filter(({ stage }) => stage.name === item.name)
              .map((element, index) => {
                return {
                  id: item.name + "_" + index + "_" + element.id,
                  content: (
                    <div>
                      <div className="rowDiv nameBoard mt-3 mb-4">
                        {/* <div>{element.id}</div> */}
                        <div
                          className="circle row_click centered-element"
                          style={{
                            backgroundColor: array.find(
                              (x) => x.id === element.id
                            ).bgdColor,
                          }}
                        >
                          <b
                            style={{
                              color: array.find((x) => x.id === element.id)
                                .textColor,
                            }}
                          >
                            {element?.name &&
                              element?.name.toUpperCase().charAt(0)}
                          </b>
                        </div>
                        <div className="ms-5 centered-element">
                          <Text variant="headingSm" as="h6">
                            {element.name}
                          </Text>
                        </div>
                      </div>
                      <div className="mt-2">
                        <p className="board-text">
                          Created at:{" "}
                          {moment(item.created_at).format(
                            "YYYY-MM-DD HH:mm:ss"
                          )}
                        </p>
                      </div>
                      <p className="board-text">
                        Type:{" "}
                        {element.type && element.type?.description
                          ? element.type?.description
                          : "-"}
                      </p>
                      <p className="board-text">
                        Campaign:{" "}
                        {element.campaign && element.campaign?.name
                          ? element.campaign?.name
                          : "-"}
                      </p>
                      <p className="board-text">
                        Contact:{" "}
                        {element.contact && element.contact?.first_name
                          ? `${
                              element?.contact?.first_name &&
                              element?.contact.first_name
                            } ${
                              element?.contact?.last_name &&
                              element?.contact.last_name
                            }`
                          : "-"}
                      </p>
                      <p className="board-text">
                        Admin:{" "}
                        {element.admin && element.admin?.first_name
                          ? `${
                              element?.admin?.first_name &&
                              element?.admin.first_name
                            } ${
                              element?.admin?.last_name &&
                              element?.admin.last_name
                            }`
                          : "-"}
                      </p>
                      <p className="board-text">
                        Price: {element.price ? element.price : "-"}
                      </p>
                      <p className="board-text">
                        Purchase Price:{" "}
                        {element.purchase_price ? element.purchase_price : "-"}
                      </p>
                      <p className="board-text">
                        Cost: {element.cost ? element.cost : "-"}
                      </p>
                      <p className="board-text">
                        Start Date:{" "}
                        {element.start_date ? element.start_date : "-"}
                      </p>
                      <p className="board-text">
                        Expected Close Date:{" "}
                        {element.expected_close_date
                          ? element.expected_close_date
                          : "-"}
                      </p>
                      <p className="board-text">
                        Actual Close Date:{" "}
                        {element.actual_close_date
                          ? element.actual_close_date
                          : "-"}
                      </p>
                    </div>
                  ),
                };
              }),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
  }
  const onDragEnd = (result, columns, setColumns) => {
    console.log("result=", result);
    console.log(result.destination.droppableId);
    console.log(
      "test1=",
      findArrayElementById(stages, result.destination.droppableId).value
    );

    console.log("test2=", result.draggableId.split("_")[2]);
    let bodyObj = {};
    if (!result.destination) return;
    const { source, destination } = result;

    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = columns[source.droppableId];
      const destColumn = columns[destination.droppableId];
      const sourceItems = [...sourceColumn.items];
      const destItems = [...destColumn.items];
      const [removed] = sourceItems.splice(source.index, 1);
      destItems.splice(destination.index, 0, removed);
      console.log("case1SOURCE=", sourceItems);
      console.log("case1DESTINATION=", destItems);
      bodyObj = {
        to_stage_id: findArrayElementById(
          stages,
          result.destination.droppableId
        ).value,
        from_deal_ids: sourceItems.map((item) =>
          parseInt(item.id.split("_")[2])
        ),
        to_deal_ids: destItems.map((item) => parseInt(item.id.split("_")[2])),
      };
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems,
        },
      });
    } else {
      const column = columns[source.droppableId];
      const copiedItems = [...column.items];
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);
      console.log("case2=", copiedItems);
      bodyObj = {
        to_stage_id: "",
        from_deal_ids: copiedItems.map((item) =>
          parseInt(item.id.split("_")[2])
        ),
        to_deal_ids: [],
      };
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...column,
          items: copiedItems,
        },
      });
    }

    axios
      .post(
        `/crm/deals/${result.draggableId.split("_")[2]}/order-stage/edit`,
        bodyObj
      )
      .then((result) => {
        // setToastContent("The status has been changed successfully");
        // toggleActive();
        // setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const capitalizeFirstLowercaseRest = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  return (
    <Page title="Deals Board" fullWidth>
      {/* <h1 style={{ textAlign: "center" }}>Jira Board</h1> */}
      {columns ? (
        <div
          style={{
            display: "flex",
            // justifyContent: "center",
            height: "100%",
            // width: "100%",
            // paddingLeft: "5rem",
          }}
        >
          <DragDropContext
            onDragEnd={(result) => onDragEnd(result, columns, setColumns)}
          >
            {Object.entries(columns).map(([columnId, column], index) => {
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                  key={columnId}
                >
                  <h2>{column.name.toUpperCase()}</h2>
                  <div style={{ margin: "8px 8px 8px 0" }}>
                    <Droppable droppableId={columnId} key={columnId}>
                      {(provided, snapshot) => {
                        return (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{
                              background: snapshot.isDraggingOver
                                ? "#ebebeb"
                                : "#ebebeb",
                              padding: 4,
                              width: 250,
                              minHeight: 500,
                              borderRadius: "3px",
                            }}
                          >
                            {column.items.map((item, index) => {
                              return (
                                <Draggable
                                  key={item.id}
                                  draggableId={item.id}
                                  index={index}
                                >
                                  {(provided, snapshot) => {
                                    return (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={{
                                          userSelect: "none",
                                          padding: 16,
                                          margin: "0 0 4px 0",
                                          minHeight: "50px",
                                          backgroundColor: snapshot.isDragging
                                            ? "#ffffff"
                                            : "#ffffff",
                                          color: "black",
                                          ...provided.draggableProps.style,
                                          borderRadius: "3px",
                                        }}
                                      >
                                        {item.content}
                                      </div>
                                    );
                                  }}
                                </Draggable>
                              );
                            })}
                            {provided.placeholder}
                          </div>
                        );
                      }}
                    </Droppable>
                  </div>
                </div>
              );
            })}
          </DragDropContext>
        </div>
      ) : (
        <div className="spinnerContainer">
          <div className="vertical-center">
            <Spinner size="large" />
          </div>
        </div>
      )}
    </Page>
  );
  function findArrayElementById(array, value) {
    return array.find((element, index) => {
      return parseInt(element.id) === parseInt(value);
    });
  }
  function rgbToObj(rgb) {
    let colors = ["red", "green", "blue", "alpha"];

    let colorArr = rgb
      .slice(rgb.indexOf("(") + 1, rgb.indexOf(")"))
      .split(", ");

    let obj = new Object();

    colorArr.forEach((k, i) => {
      obj[colors[i]] = k;
    });

    return obj;
  }
};

export default DealsBoard;
